import PlaceModel from '@/core/Address/model/PlaceModel.js';
import PictureCampaignModel from '@/core/Campaign/model/PictureCampaignModel.js';
import RelateCampaignModel from '@/core/Campaign/model/RelateCampaignModel.js';
import SubCampaignModel from '@/core/Campaign/model/SubCampaignModel.js';
import { SurveyModel, SurveyAdsModel, SurveyActionModel, SurveyVideoMediaModel } from '@/core/Campaign/model/SurveyModel.js';
// import PurchaseModel from '@/model/PurchaseModel.js';

export default function RewardCampaignModel(dict) {
    var i;
    this.adsMessage = dict.AdsMessage;
    this.agencyAddress = dict.AgencyAddress;
    this.agencyCity = dict.AgencyCity;
    this.agencyCountry = dict.AgencyCountry;
    this.agencyEmail = dict.AgencyEmail;
    this.agencyFAX = dict.AgencyFAX;
    this.agencyID = dict.AgencyID;
    if (!this.agencyID)
        this.agencyID = dict.AgencyId;


    this.agencyLogoUrl = dict.AgencyLogoUrl;
    this.agencyName = dict.AgencyName;
    this.agencyTel = dict.AgencyTel;
    this.agencyWebsite = dict.AgencyWebsite;
    this.agencyZipCode = dict.AgencyZipCode;

    this.badgeJson = dict.BadgeJson;
    this.badges = dict.Badges;
    this.barcode = dict.Barcode;
    if (!this.barcode)
        this.barcode = "";

    this.bidStartPoint = dict.BidStartPoint;
    this.bidStepPoint = dict.BidStepPoint;
    this.bidUsePoint = dict.BidUsePoint;
    this.buzz = dict.Buzz;

    this.caption = dict.Caption;
    this.categoryDashboardSize = dict.CategoryDashboardSize;
    this.categoryID = dict.CategoryID;
    if (!this.categoryID)
        this.categoryID = dict.CategoryId;

    this.categoryName = dict.CategoryName;
    this.categorySequence = dict.CategorySequence;
    this.condition = dict.Condition;
    this.conditionAlert = dict.ConditionAlert
    this.conditionAlertId = dict.ConditionAlertId;
    this.coolDown = dict.CoolDown;
    this.createBy = dict.CreateBy;
    this.createDate = dict.CreateDate;
    this.crossAppCampaignId = dict.CrossAppCampaignId;
    this.currentDate = dict.CurrentDate;
    this.customCaption = dict.CustomCaption;
    this.customFacebookMessage = dict.CustomFacebookMessage;
    this.customInput = dict.CustomInput;

    this.dayProceed = dict.DayProceed;
    this.dayRemain = dict.DayRemain;
    this.daysValidAfterExpire = dict.DaysValidAfterExpire;
    this.defaultPrivilegeMessage = dict.DefaultPrivilegeMessage;

    this.delivered = dict.Delivered;
    if (!this.delivered)
        this.delivered = false;

    this.deliveryJson = dict.DeliveryJson;
    this.detail = dict.Detail;
    this.discount = dict.Discount;

    this.emsDeliveryCostPerUnit = dict.EMSDeliveryCostPerUnit;
    this.expireDate = dict.ExpireDate;
    this.extra = dict.Extra;
    this.expireIn = dict.ExpireIn;

    this.fanPageId = dict.FanPageId;
    this.hasCrossApp = dict.HasCrossApp;
    this.hashTagJson = dict.HashTagJson;
    this.hasWinner = dict.HasWinner;

    this.id = dict.ID;
    this.interfaceDisplay = dict.InterfaceDisplay;
    this.isCheckUserCampaignPermission = dict.IsCheckUserCampaignPermission;
    this.isConditionPass = dict.IsConditionPass;
    this.isFavourite = dict.IsFavourite;
    this.isHighlight = dict.IsHighlight;

    this.isLike = dict.IsLike;
    if (!this.isLike)
        this.isLike = false;

    this.isNotAutoUse = dict.IsNotAutoUse;
    this.isRequirePoints = dict.IsRequirePoints;
    this.isRequireUniqueSerial = dict.IsRequireUniqueSerial;
    this.isShowNotiNearby = dict.IsShowNotiNearby;
    this.isSpecificLocation = dict.IsSpecificLocation;
    this.isSpecificPrintVoucher = dict.IsSpecificPrintVoucher;
    this.isSplitPointSystem = dict.IsSplitPointSystem;
    this.isSponsor = dict.IsSponsor;
    this.itemCountSold = dict.ItemCountSold;

    this.keyword = dict.Keyword;

    // Location && Place
    // GuG|20190117 : handle for campaign list and campaign detail api sent a diffent property.
    // So we if thier is either location or place it's going to add in to property.
    this.location = [];
    this.places = [];
    if (dict.Locations && dict.Locations instanceof Array) {
        if (dict.Locations.length > 0) {
            for (i = 0; i < dict.Locations.length; i++) {
                var itemLocation = dict.Locations[i];
                this.location.push(new PlaceModel(itemLocation));
                this.places.push(new PlaceModel(itemLocation));
            }
        }
    } else if (dict.Places && dict.Places instanceof Array) {
        if (dict.Places.length > 0) {
            for (i = 0; i < dict.Places.length; i++) {
                var itemPlace = dict.Places[i];
                this.location.push(new PlaceModel(itemPlace));
                this.places.push(new PlaceModel(itemPlace));
            }
        }
    }

    this.latestVoteDate = dict.LatestVoteDate;
    this.locationAgencyId = dict.LocationAgencyId;

    this.masterCampaignId = dict.MasterCampaignId;
    this.merchantStatusId = dict.MerchantStatusId;
    this.minutesValidAfterUsed = dict.MinutesValidAfterUsed;
    this.modifyBy = dict.ModifyBy;
    this.modifyDate = dict.ModifyDate;

    this.name = dict.Name;
    this.nextRedeemDate = dict.NextRedeemDate;
    this.notificationCount = dict.NotificationCount;

    this.originalPrice = dict.OriginalPrice;
    this.otherPointPerUnit = dict.OtherPointPerUnit;

    this.parentCampaignId = dict.ParentCampaignId;
    if (!this.parentCampaignId) {
        this.parentCampaignId = dict.ParentCampaignID;
    }

    this.parentCategoryID = dict.ParentCategoryID;
    if (!this.parentCategoryID) {
        this.parentCategoryID = dict.ParentCategoryId;
    }

    //Added 08/08/2019
    this.partialPoints = dict.PartialPoints;

    this.peopleDislike = dict.PeopleDislike;
    this.peopleFavourite = dict.PeopleFavourite;
    this.peopleLike = dict.PeopleLike;

    if (this.peopleLike > 0) {
        //nothing
    } else {
        // support case like in list
        var intLike = dict.Like;
        if (intLike != 0) {
            this.peopleLike = intLike;
        }
    }

    this.peopleVote = dict.PeopleVote;

    this.pictures = [];
    if (dict.Pictures) {
        for (i = 0; i < dict.Pictures.length; i++) {
            var itemPicture = dict.Pictures[i];
            this.pictures.push(new PictureCampaignModel(itemPicture));
        }
    }

    this.pointPerUnit = dict.PointPerUnit;
    this.pointType = dict.PointType;
    this.pricePerUnit = dict.PricePerUnit;
    this.privilegeMessage = dict.PrivilegeMessage;
    this.privilegeMessageFormat = dict.PrivilegeMessageFormat;

    this.qty = dict.Qty;
    this.quantity = dict.Quantity;

    this.rankFavourite = dict.RankFavourite;
    this.rankLike = dict.RankLike;
    this.rankVote = dict.RankVote;
    this.rating = dict.Rating;
    this.redeemCount = dict.RedeemCount;
    this.redeemDate = dict.RedeemDate;
    this.redeemMedia = dict.RedeemMedia;
    this.redeemMostPerPerson = dict.RedeemMostPerPerson;
    this.redeems = dict.Redeems;
    this.refAISCampaignID = dict.RefAISCampaignID;
    this.referenceCode = dict.ReferenceCode;
    this.refPTTAgencyID = dict.RefPTTAgencyID;
    this.regularDeliveryCostPerUnit = dict.RegularDeliveryCostPerUnit;

    this.related = [];
    if (dict.Related) {
        var objRelated = dict.Related;
        for (i = 0; i < objRelated.length; i++) {
            var itemRelated = objRelated[i];
            // บางแอพดาต้าที่ส่งมาใน related บางทีก็เป็นแบบ relateCampaign class บางทีก็เป็น campaign class เลย
            // ที่ต้องเช็คด้วย Type เพราะใน relateCampaign ไม่มีการส่ง Type มาให้
            if (itemRelated.Type) {
                this.related.push(new RewardCampaignModel(itemRelated));
            } else {
                this.related.push(new RelateCampaignModel(itemRelated));
            }
        }
    }

    this.score = dict.Score;
    this.sendNotifications = dict.SendNotifications;
    this.serial = dict.Serial;
    this.serialCount = dict.SerialCount;
    this.serialFormat = dict.SerialFormat;
    this.serialPreFix = dict.SerialPreFix;
    this.shippingBy = dict.ShippingBy;
    this.shippingPayment = dict.ShippingPayment;
    this.soldOutDate = dict.SoldOutDate;
    this.specifyBranch = dict.SpecifyBranch;
    this.sponsorCategoryName = dict.SponsorCategoryName;
    this.startDate = dict.StartDate;
    this.statusID = dict.StatusID;
    this.styleJson = dict.StyleJson;
    this.subCampaigns = dict.SubCampaigns;
    this.subCampaignStyles = dict.SubCampaignStyles;

    this.termsAndConditions = dict.TermsAndConditions;
    this.timeRounding = dict.TimeRounding;
    this.topVotes = dict.TopVotes;
    this.tracesJson = dict.TracesJson;
    this.type = dict.Type;

    this.under18 = dict.Under18;
    this.updated_points = dict.updated_points;
    this.updated_points_other = dict.updated_points_other;
    this.useCount = dict.UseCount;
    this.useLevel = dict.UseLevel;
    this.userPackagePoints = dict.UserPackagePoints;
    this.userPackagePrices = dict.UserPackagePrices;
    this.userProfileScore = dict.UserProfileScore;
    this.userRequirePoints = dict.UserRequirePoints;
    this.userSummaryPrices = dict.UserSummaryPrices;
    this.userVisibility = dict.userVisibility;

    this.visibility = dict.Visibility;
    this.voucherExpireDate = dict.VoucherExpireDate;

    this.website = dict.Website;
    this.winnerUserId = dict.WinnerUserId;
    this.winnerUserName = dict.WinnerUserName;

    // fullImageUrl เขาไม่ได้ใส่ type large มาให้ ต้องใส่เอง
    this.fullImageUrl = dict.FullImageUrl;
    if (this.fullImageUrl) {
        if (this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }

    this.listSubCampaign = [];
    if (dict.SubCampaignStyles && dict.SubCampaignStyles.styles) {
        if (dict.SubCampaignStyles.styles instanceof Array) {
            for (i = 0; i < dict.SubCampaignStyles.styles.length; i++) {
                var itemStyle = dict.SubCampaignStyles.styles[i];
                this.listSubCampaign.push(new SubCampaignModel(itemStyle));
            }
        }
    }

    // ทำเรื่อง survey
    var listVideoDownload = [];
    if (dict.Extra) {
        var json = JSON.parse(dict.Extra);
        // ส่วนของ ads
        if (json.ad) {
            this.surveyAds = new SurveyAdsModel(json);
        }

        // ส่วนของ survey
        if (json.survey) {
            this.survey = new SurveyModel(json);
        }

        // ส่วนของ action
        if (json.action) {
            this.surveyAction = new SurveyActionModel(json);
        }

        // ส่วนของ media
        if (json.media) {
            if (json.media.videos && json.media.videos instanceof Array) {
                for (i = 0; i < json.media.videos.length; i++) {
                    listVideoDownload.push(new SurveyVideoMediaModel(json.media.videos[i]));
                }
            }
        }
    }

    // Replace serial in privilege message
    if (this.privilegeMessage && this.serial) {
        this.privilegeMessage = this.privilegeMessage.replace("<serial>", this.serial);
    }

    this.updateAfterRedeem = function (dict) {
        this.redeemCount = dict.RedeemCount;
        if (dict.RedeemDate)
            this.redeemDate = dict.RedeemDate;

        this.serial = dict.Serial;
        this.nextRedeemDate = dict.NextRedeemDate;
        this.useCount = dict.UseCount;
        this.qty = dict.Qty;
        this.isConditionPass = dict.IsConditionPass;
        this.adsMessage = dict.AdsMessage;
        this.expireIn = dict.ExpireIn;
        this.isNotAutoUse = dict.IsNotAutoUse;
        this.privilegeMessage = dict.PrivilegeMessage;

        if (dict.buzzebees)
            this.buzzebees = dict.buzzebees;

        if (dict.privilegeMessageEN)
            this.privilegeMessageEN = dict.privilegeMessageEN;

        if (dict.PrivilegeMessageEN)
            this.privilegeMessageEN = dict.PrivilegeMessageEN;

        this.privilegeMessageFormat = dict.PrivilegeMessageFormat;
        this.pointType = dict.PointType;
        this.conditionAlert = dict.ConditionAlert;
        this.conditionAlertId = dict.ConditionAlertId;
        this.currentDate = dict.CurrentDate;

        // support purchase
        this.parcelNo = dict.ParcelNo;
        this.isShipped = dict.IsShipped;
        if (dict.RedeemKey)
            this.redeemKey = dict.RedeemKey;

        // Replace serial in privilege message
        if (this.privilegeMessage && this.serial)
            this.privilegeMessage = this.privilegeMessage.replace("<serial>", this.serial);

        if (this.privilegeMessageEN && this.serial)
            this.privilegeMessageEN = this.privilegeMessageEN.replace("<serial>", this.serial)
    };

    this.updateCampaign = function (dict) {
        this.redeemCount = dict.redeemCount;
        if (dict.redeemDate)
            this.redeemDate = dict.redeemDate;

        this.serial = dict.serial;
        this.nextRedeemDate = dict.nextRedeemDate;
        this.useCount = dict.useCount;
        this.qty = dict.qty;
        this.isConditionPass = dict.isConditionPass;
        this.adsMessage = dict.adsMessage;
        this.expireIn = dict.expireIn;
        this.isNotAutoUse = dict.isNotAutoUse;
        this.privilegeMessage = dict.privilegeMessage;

        if (dict.buzzebees)
            this.buzzebees = dict.buzzebees;

        if (dict.privilegeMessageEN)
            this.privilegeMessageEN = dict.privilegeMessageEN;

        if (dict.PrivilegeMessageEN)
            this.privilegeMessageEN = dict.PrivilegeMessageEN;

        this.privilegeMessageFormat = dict.privilegeMessageFormat;
        this.pointType = dict.pointType;
        this.conditionAlert = dict.conditionAlert;
        this.conditionAlertId = dict.conditionAlertId;
        this.currentDate = dict.currentDate;

        // support purchase
        this.parcelNo = dict.parcelNo;
        this.isShipped = dict.isShipped;
        if (dict.redeemKey)
            this.redeemKey = dict.redeemKey;

        // Replace serial in privilege message
        if (this.privilegeMessage && this.serial)
            this.privilegeMessage = this.privilegeMessage.replace("<serial>", this.serial);

        if (this.privilegeMessageEN && this.serial)
            this.privilegeMessageEN = this.privilegeMessageEN.replace("<serial>", this.serial)
    };

    this.updateCampaignExpired = function () {
        this.serial = "XXXXXXX";
        this.expireIn = -1;
    };

    this.initWithPurchase = function (purchaseModel) {
        this.agencyName = purchaseModel.agencyName;
        this.barcode = purchaseModel.barcode;
        this.condition = purchaseModel.condition;
        this.expireIn = purchaseModel.expireIn;
        this.fullImageUrl = purchaseModel.fullImageUrl;
        this.name = purchaseModel.name;
        this.redeemDate = purchaseModel.redeemDate;
        this.serial = purchaseModel.serial;
        this.privilegeMessageFormat = purchaseModel.privilegeMessageFormat;

        // support purchase
        this.parcelNo = purchaseModel.parcelNo;
        this.isShipped = purchaseModel.isShipped;
        this.redeemKey = purchaseModel.redeemKey;

        // Replace serial in privilege message
        if (this.privilegeMessage && this.serial) {
            this.privilegeMessage = this.privilegeMessage.replace("<serial>", this.serial);
        }
    };
}

